import { tl } from 'common/services/i18nService';
import * as moment from 'moment';
import { HitData } from 'common/store/common/search/types';
import { GradeType, Evaluator } from '../store/assessment/reducer';
import { GRADING_PARTY_INDEX } from '../store/common/search/constants';
import { GradingPartySubmissionStatus } from '../features/table/types';

export const getGradeTranslatedLabel = (gradeKeyAsString: string): string => {
    const gradeCaptionKey = `grading.gradeType.${gradeKeyAsString}`;
    const translatedGradeCaption = tl(gradeCaptionKey);
    // if by any chance there is no caption, use the grade itself
    return translatedGradeCaption === gradeCaptionKey ? gradeKeyAsString : translatedGradeCaption;
};
export const getSortedGradesRangeArray = (gradeTypeValues: GradeType, useKeyAsValue?: boolean) => {
    const gradeScale: string[] = Object.keys(gradeTypeValues);
    const valuesInRange = gradeScale.map((grade: string) => ({
        value: useKeyAsValue ? grade : gradeTypeValues[grade],
        key: gradeTypeValues[grade],
        text: `${getGradeTranslatedLabel(grade)}`,
        id: `grade_${grade}`,
    }));
    // sort grades by value
    const keySortUsingGradeValues = (a: any, b: any) => gradeTypeValues[a.value] - gradeTypeValues[b.value];
    const sortUsingGradeValues = (a: any, b: any) => a.value - b.value;
    return valuesInRange.sort(useKeyAsValue ? keySortUsingGradeValues : sortUsingGradeValues);
};

export const getMarkEvaluator = (evaluatorId: number, allEvaluators: Evaluator[]) => {
    return allEvaluators?.find((evaluator: any) => {
        return evaluator.id === evaluatorId;
    });
};

export const getDetailsPanelSelectedContextKey = (userId: number, assessmentRunId: number) => {
    return `details_panel_selected_context_${userId}_${assessmentRunId}`;
};

export const getCountdownCaption = (endTimeMoment: any, maxExtraTime: any) => {
    if (maxExtraTime > 0) {
        endTimeMoment.add(maxExtraTime, 'minutes');
    }

    return tl('grading.header.progress.closesIn', {
        remainingTime: getFormattedDuration(moment(), endTimeMoment),
    });
};

export const getFormattedDuration = (initialMoment: any, targetMoment: any) => {
    const diff = initialMoment.diff(
        targetMoment
    );
    const remainingDurationMoment = moment.duration(
        diff < 0 ? diff * -1 : diff
    );
    const daysFormatString = remainingDurationMoment.days() > 0
        ? `dd [${tl('grading.general.dayOrDays')}] `
        : '';
    const formatString = `${daysFormatString}HH:mm:ss`;
    return remainingDurationMoment.format(formatString, {
        trim: false,
    });
};

export const isChromium = !!(window as any).chrome;

export const shouldUseListGradingPartyApi = (
    dataType: string,
    questionId: number,
    hasPullingSections: boolean,
    hasManualSelectionSections: boolean
) => {
    return dataType === GRADING_PARTY_INDEX
        && questionId > 0
        && (hasPullingSections || hasManualSelectionSections);
};

export const parseDateTime = (dateTime: string, inputDateFormat: string, outputDateFormat: string) => {
    return moment.utc(dateTime, inputDateFormat).local().format(outputDateFormat);
};

export const isSubmissionDeleted = (
    hitData: HitData
) => {
    return hitData.submissionStatus === GradingPartySubmissionStatus.DELETED;
};
